import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { PowerLimitationHistoryActions } from './power-limitation-history.actions';
import { PowerLimitationHistorySelectors } from './power-limitation-history.selectors';

import {
  PowerLimitationControlCommandType,
  PowerLimitationFilterDateAndType,
} from './power-limitation-history.model';

@Injectable({ providedIn: 'root' })
export class PowerLimitationHistoryStore {
  controlCommandFilterType$ = this.store.select(
    PowerLimitationHistorySelectors.selectControlCommandType()
  );
  filterDateType$ = this.store.select(PowerLimitationHistorySelectors.selectFilterDateType());
  filterDateAndType$ = this.store.select(PowerLimitationHistorySelectors.selectFilterDateAndType());
  filteredData$ = this.store.select(PowerLimitationHistorySelectors.selectFilteredData());
  powerLimitationAmount$ = this.store.select(
    PowerLimitationHistorySelectors.selectPowerLimitationAmount()
  );
  consumptionLimitationAmount$ = this.store.select(
    PowerLimitationHistorySelectors.selectConsumptionLimitationAmount()
  );
  productionLimitationAmount$ = this.store.select(
    PowerLimitationHistorySelectors.selectProductionLimitationAmount()
  );
  loading$ = this.store.select(PowerLimitationHistorySelectors.selectLoading());

  constructor(private store: Store) {}

  loadData(): void {
    this.store.dispatch(PowerLimitationHistoryActions.getPowerLimitationData.attempt());
  }

  clearState(): void {
    this.store.dispatch(PowerLimitationHistoryActions.clearState.attempt());
  }

  setFilterDateType(filterDateAndType: PowerLimitationFilterDateAndType): void {
    this.store.dispatch(
      PowerLimitationHistoryActions.updateFiltersByDate.attempt({ filterDateAndType })
    );
  }

  updateFiltersByPowerLimitationControlCommandType(
    powerLimitationControlCommandType: PowerLimitationControlCommandType
  ): void {
    this.store.dispatch(
      PowerLimitationHistoryActions.updateFiltersByPowerLimitationType.attempt({
        powerLimitationControlCommandType,
      })
    );
  }
}
